import { createSlice } from '@reduxjs/toolkit'

import { ApiError, NameSpace, SliceStatus } from 'src/Redux/types'
import { setApiError } from 'src/Hooks/redux'

import { checkUserEmailToSignIn } from './api-actions'

/**
 * BE returns this `type` when the email has no account. The redesigned First
 * step shows this inline on the email field instead of switching screens, so
 * the reducer must not overwrite `authType` for this specific value.
 */
export const USER_NOT_FOUND_TYPE = 'userIsNotExist'
const MAGIC_LINK_TYPE = 'withoutSignup'

export interface AuthTypeState {
  authType: string
  email: string
  status: SliceStatus
  error: ApiError | null
}
const initialState: AuthTypeState = {
  authType: 'login',
  email: '',
  status: SliceStatus.Idle,
  error: null,
}
export const authTypeSlice = createSlice({
  initialState,
  name: NameSpace.AuthType,
  reducers: {
    setLoginTypeToInitialState: (state) => {
      state.authType = 'login'
      state.email = ''
    },
    switchToMagicLink: (state) => {
      state.authType = MAGIC_LINK_TYPE
    },
  },
  extraReducers(builder) {
    builder.addCase(checkUserEmailToSignIn.pending, (state) => {
      state.status = SliceStatus.Loading
    })
    builder.addCase(checkUserEmailToSignIn.fulfilled, (state, action) => {
      state.status = SliceStatus.Succeeded
      if (action.payload.type !== USER_NOT_FOUND_TYPE) {
        state.authType = action.payload.type
      }
      state.email = action.meta.arg
    })
    builder.addCase(checkUserEmailToSignIn.rejected, (state, action) => {
      state.status = SliceStatus.Failed
      state.error = setApiError(action)
    })
  },
})

export const { setLoginTypeToInitialState, switchToMagicLink } =
  authTypeSlice.actions
